<template>
    <ResultsNetworkBanner bannerType="success" header="In network">
        <ApplicationTier :result="result" :tierLabel="currentPlanTierLabel" v-if="currentPlanIsTiered && result.tier" />
        <span >Check your <a href="/my/plan-overview/coverage.html" :data-card-rank="rank">coverage details</a> to learn more.</span>     
    </ResultsNetworkBanner>
</template>

<script setup>

    const props = defineProps({
        result: Object,
        rank: Number
    })

    const { plan, currentPlanTierLabel, currentPlanIsTiered } = useFCPModel()

</script>
